import React, { useState } from "react";
import Select from "react-select";

const EmployeeLeaveList = ({ data , setFilter, filter }) => {


  const options = [
    { value: "thisWeek", label: "This Week" },
    { value: "nextWeek", label: "Next Week" },
  ];

    //  "approved_leaves_data": [
  //         {
  //             "staff_id": 18,
  //             "staff_name": "Fredric Frances",
  //             "leave_type": "Full",
  //             "reason": "Something Urgent",
  //             "date": "2025-08-05"
  //         },
  //         {
  //             "staff_id": 18,
  //             "staff_name": "Fredric Frances",
  //             "leave_type": "Full",
  //             "reason": "Something Urgent",
  //             "date": "2025-08-06"
  //         },
  //         {
  //             "staff_id": 18,
  //             "staff_name": "Fredric Frances",
  //             "leave_type": "Full",
  //             "reason": "Something Urgent",
  //             "date": "2025-08-07"
  //         }
  //     ]
  // }
function getDay(dateString) {
  const date = new Date(dateString); // Convert string to Date object
  const day = String(date.getDate()).padStart(2, '0'); // Ensure day is two digits

  return day; // Return only the day part
}

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="card-title mb-0">Employee On Leave</h5>
        <div style={{ minWidth: "150px" }}>
          <Select
            options={options}
            defaultValue={options[0]}
            onChange={(selectedOption) => setFilter(selectedOption.value)}
            className="react-select-container"
            classNamePrefix="react-select"
            isSearchable={false}
          />
        </div>
      </div>

    <ul className="list-group birthday-list">
  {data?.length === 0 ? (
    <li className="list-group-item text-center" style={{ padding: "20px", marginTop: "10px" }}>
      No data available
    </li>
  ) : (
    data?.map((emp, index) => (
      <li key={index} className="list-group-item d-flex align-items-center">
        <div className="avatar me-3">{emp?.staff_name.charAt(0).toUpperCase()}</div>
        <div className="flex-grow-1">
          <strong>{emp.staff_name}</strong><br />
          <span className="text-muted">Leave Date: {emp.date}</span>
        </div>
        <div className="date-badge">{getDay(emp.date)}</div>
      </li>
    ))
  )}
</ul>

    </div>
  );
};

export default EmployeeLeaveList;
